export default defineNuxtPlugin((nuxtApp: any) => {
  nuxtApp.$router.options.scrollBehavior = (to: any, from: any, savedPosition: any) => {
    return { top: 0 };
  }

  if (window && window.history) {
    window.history.scrollRestoration = 'manual';
  }
})